import { Drawer, Toolbar, Box, useMediaQuery } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MERCHANT_TABS } from './MerchantTabsList';
import { includes } from 'lodash';
import { DrawerList, DrawerAccountWelcome } from '../components';
import { useLocation } from 'react-router-dom';
import { ENAAB_ID, IRONER, USER_ROLES_TYPES } from 'src/constants';
import { omitNestedObject } from 'src/_utils';
import { useGetDeliverySettingQuery } from 'src/_api/authApi';
import { Equalizer, Paid } from '@mui/icons-material';
const drawerWidth = 260;

export default function MapitDrawer({ openDrawer, toggleDrawer }) {
    const { pathname } = useLocation();
    const { data: deliverySetting } = useGetDeliverySettingQuery()

    const profile = useSelector((state) => state.entities.profile.profile);

    const { newFailedOrdersCount, newSuccessfulOrdersCount } = useSelector((state) => state.entities.completedOrdersCount)

    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));

    const Tabs = useMemo(() => {
        let tabs = []

        if (profile?.merchant?.DMS) {
            tabs = MERCHANT_TABS(newSuccessfulOrdersCount, newFailedOrdersCount).filter((tab) => {
                if (!["Create task", "Private connections", "Integrations"].includes(tab.title)) {
                    return tab
                }
            })
        }

        tabs = MERCHANT_TABS(newSuccessfulOrdersCount, newFailedOrdersCount)

        if (profile?.type !== USER_ROLES_TYPES.ADMIN) {
            tabs = tabs?.filter(el => el.title !== "Account")
        }

        const deliveryMethod = profile?.merchant?.deliveryMethod || [];

        if (!deliveryMethod?.includes("MAPIT_SHIP")) {
            tabs = tabs?.filter(el => !["Mapit Ship"].includes(el.title))
        }

        if (deliveryMethod?.length === 1 && deliveryMethod?.includes("MAPIT_SHIP")) {
            let excludeHrefs = [
                "/merchant/tasks/create",
                "/merchant/orders/filter",
                "/merchant/all-tasks/zone?status=TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF",
                "/merchant/tasks/filter",
                "/merchant/connections",
                "/merchant/drivers",
                "/merchant/zones",
                "/merchant/settings/whatsapp",
                "/merchant/customizations",
                "/merchant/account/plans",
                "/merchant/account/subscription",
                "/merchant/all-orders/zone?status=UNASSIGNED&type=PICK_UP"
            ];

            if (profile?.merchant?.mottasl?.active) {
                excludeHrefs = excludeHrefs.filter(el => el !== "/merchant/settings/whatsapp")
            }

            tabs = tabs?.filter(el => {
                // Exclude if el.href matches
                if (includes(excludeHrefs, el.href)) return false;
                // Exclude if any child.href matches
                if (el.children && el.children.length) {
                    el.children = el.children.filter(child => !includes(excludeHrefs, child.href));
                    // Optionally remove tab if all children are filtered out
                    if (el.children.length === 0) return false;
                }
                return true;
            });
        } else if (deliveryMethod?.length === 1 && deliveryMethod?.includes("MYSELF") && profile?.merchant?.onlinePayment) {
            tabs.splice(6, 0, {
                href: "/merchant/cod-invoices",
                icon: Paid,
                title: "COD Wallet",
            });
        }

        if (!deliverySetting?.reschduleDeliveryDate) {
            if (!!deliverySetting?.ordersCount) return tabs
            tabs = omitNestedObject(tabs, 'title', 'Rescheduled Orders');
        }

        if (!profile?.merchant?.onlinePayment) {
            tabs = tabs?.filter(el => el.href !== "/merchant/transactions")
        }

        if (!!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id || [...IRONER].includes(profile?.merchant?.id)) {
            let index = tabs?.findIndex(el => el.title === "Account")
            if (index !== -1) {
                tabs[index].children = tabs[index]?.children?.filter(el => !["/merchant/account/plans", "/merchant/account/subscription"].includes(el.href))
            }
        }

        if (!profile?.merchant?.isNationalAddressEnabled) {
            tabs = tabs?.filter(el => !["/merchant/national-address-transactions"].includes(el.href))
        }

        const isEnaab = ENAAB_ID.includes(profile?.merchant?.id)
        if (isEnaab) {
            let index = tabs?.findIndex(el => el.href === "/merchant/drivers")
            tabs.splice(index + 1, 0, {
                href: "/merchant/drivers/stats",
                icon: Equalizer,
                title: "Drivers Stats",
            });
        }

        return tabs
    }, [newFailedOrdersCount, newSuccessfulOrdersCount, profile, deliverySetting])

    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);

    const { openDrawer: openDrawerState, run } = useSelector((state) => state.entities.tutorial);

    return (
        <Drawer
            open={openDrawer || openDrawerState}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box id="drawer-app-id" sx={{ overflowY: run ? "auto" : "auto !important", overflowX: 'hidden' }}>
                <DrawerAccountWelcome companyName={profile?.merchant?.companyName} logo={profile?.merchant?.logo} />
                {/* {
                    !!profile?.merchant?.currentStatus && includes(["BLOCKED", "WAITING", "PLAN_EXPIRED", "CARD_REQUIRED"], profile?.merchant?.currentStatus) &&
                    <DrawerCurrentUserStatus currentStatus={profile?.merchant?.currentStatus} />
                } */}
                <DrawerList tabs={Tabs} />
            </Box>
        </Drawer>
    )
}